import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-[#E8ECF1] flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO title="404" description="Page introuvable" noIndex />
      <div className="text-center max-w-md">
        <div className="relative mb-8">
          <p className="text-[120px] font-black text-slate-200 leading-none select-none" style={{ fontFamily: 'Poppins' }}>404</p>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search className="w-16 h-16 text-blue-500 opacity-60" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Poppins' }}>
          {isFr ? 'Page introuvable' : 'Page Not Found'}
        </h1>
        <p className="text-slate-500 mb-8">
          {isFr
            ? "La page que vous cherchez n'existe pas ou a été déplacée."
            : "The page you're looking for doesn't exist or has been moved."}
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2" data-testid="go-back-btn">
            <ArrowLeft className="w-4 h-4" />
            {isFr ? 'Retour' : 'Go Back'}
          </Button>
          <Button onClick={() => navigate('/')} className="bg-blue-600 hover:bg-blue-700 text-white gap-2" data-testid="go-home-btn">
            <Home className="w-4 h-4" />
            {isFr ? 'Accueil' : 'Home'}
          </Button>
        </div>
      </div>
    </div>
  );
}
